/*****************************************************************************************
 * 설명 : 시스템관리 > 사용자권한관리
 * URI : /system/EmployeeAuthManagement
 * 작성자 : 송영석
 * 작성일 : 2023-03-26
*****************************************************************************************/
import { Button, Checkbox } from '@mui/material';
import { AgGridReact } from 'ag-grid-react';
import { useFormik } from 'formik';
import 'moment/locale/ko';
import { useEffect, useRef, useState } from 'react';
import SplitPane from "react-split-pane";

import BtnAgGridSave from 'components/btnAgGridSave';
import { BtnSearch } from 'components/common';
import { ButtonEx, SelectEx } from 'components/inputEx';
import alertMsg from "components/message";

import { MESSAGE_DELAY } from 'config/config';
import useGridConfig from 'hooks/useGridConfig';

import Restful from 'service/restful';
import { getSelectData } from 'service/utils';

import Layout from '../layout/layout';

/*****************************************************************************************
 * 설명 : 함수 선언
*****************************************************************************************/
function Auth(props) {

  /***************************************************************************************
   * 설명 : 변수 선언부
  ***************************************************************************************/
  const [getApi] = Restful();

  const gridRef = useRef();

  const [siteList, setSiteList] = useState([]);

  // 권한그룹 권한 리스트 AgGrid API
  const [gridApiList, setGridApiList] = useState(null);

  const [authgroupSeq, setAuthgroupSeq] = useState('');

  const formik = useFormik({
    initialValues: {
      siteSeq: null,
    },
    onSubmit: (values) => {
      //onRowClickedGroup();
    }
  });

  // 권한그룹 컬럼 선언
  const [columnDefsGroup, setColumnDefsGroup] = useState([
    { headerName: '관리번호(관리자용)', field: 'seq', cellClass: 'cp', width: 36, headerCheckboxSelection: true, headerCheckboxSelectionFilteredOnly: true, checkboxSelection: true },
    { headerName: '권한그룹명', field: 'groupName', width: 250, cellClass: 'cp' },
  ]);

  // 권한그룹 데이터
  const [groupList, setGroupList] = useState([]);
  const [gridConfigGroup, setGridUpdateGroup] = useGridConfig(1, setColumnDefsGroup);

  /***************************************************************************************
   * 설명 : 헤더 체크
  ***************************************************************************************/
  function agGridHeaderCheckbox(params, props) {
    const className = ( props.className !== undefined ) ? 'Checkbox ' + props.className : 'Checkbox';

    return (
      <>
        <Checkbox
          className={className}
          onChange={(e) => {setColumnAll(e, params)}}
          color="primary"
        />
        <span>{params.displayName}</span>
      </>
    )
  }

  /***************************************************************************************
   * 설명 : 체크박스 처리
  ***************************************************************************************/
  function agGridCheckbox(params, props) {
    let check = ( params.value === '0' || params.value === null || params.value === 0 ) ? false : true;
    const className = ( props.className !== undefined ) ? 'Checkbox ' + props.className : 'Checkbox';

    return (
      <Checkbox className={className}
        onChange={(e) => {setColumnCheck(e, params)}}

        // onChange={(event) => {
        //   params.node.data[params.colDef.field] = event.target.checked === false ? 0 : 1;
        //   params.api.updateRowData({ update: [params.node.data]});
        // }}
        checked={check}
        color="primary"
      />
    )
  }

  // 권한그룹 설정 컬럼 정보
  const [columnDefsAuth, setColumnDefsAuth] = useState([
    { headerName: '관리번호(관리자용)', field: 'checkrow', cellClass: 'cp', width: 60,
      cellRenderer: function(params) {
        let check = ( params.value === 0 || params.value === null || params.value === undefined ) ? false : true;
        const className = ( props.className !== undefined ) ? 'Checkbox ' + props.className : 'Checkbox';

        return (
          <Checkbox
            className={className}
            onChange={(event) => {
              params.node.data.checkrow = event.target.checked === false? 0 : 1;
              params.node.data.authView = event.target.checked === false? 0 : 1;
              params.node.data.authWrite = event.target.checked === false? 0 : 1;
              params.node.data.authModify = event.target.checked === false? 0 : 1;
              params.node.data.authDelete = event.target.checked === false? 0 : 1;
              params.node.data.authExcel = event.target.checked === false? 0 : 1;
              params.node.data.authEmail = event.target.checked === false? 0 : 1;
              params.node.data.authKakao = event.target.checked === false? 0 : 1;
              params.node.data.authSms = event.target.checked === false? 0 : 1;
              params.node.data.authAdmin = event.target.checked === false? 0 : 1;

              params.api.forEachNode( (node) => {
                if( event.target.checked ) {
                  node.updateData(node.data);
                } else {
                  node.updateData(node.data);
                }
              });
            }}
            checked={check}
            color="primary"
          />
        )
      },
    },
    { headerName: '메뉴명', field: 'pageName', width: 300, cellClass: 'cp',
      valueGetter: (params) => {
        let level = Math.round(params.data.pageCode.length / 3);
        let space = '';
        for(let i = 0; i < level; i++) space += 'ㅤㅤ';
        return space + params.data.pageName;
      }
    },
    { headerName: '조회', field: 'authView', cellClass: 'cp center', width: 100, suppressMenu: true,
      cellRenderer: (params) => agGridCheckbox(params, props),
      headerComponentFramework: (params) => agGridHeaderCheckbox(params, props)
    },
    { headerName: '등록', field: 'authWrite', cellClass: 'cp center', width: 100,
      cellRenderer: (params) => agGridCheckbox(params, props),
      headerComponentFramework: (params) => agGridHeaderCheckbox(params, props)
    },
    { headerName: '수정', field: 'authModify', cellClass: 'cp center', width: 100,
      cellRenderer: (params) => agGridCheckbox(params, props),
      headerComponentFramework: (params) => agGridHeaderCheckbox(params, props)
    },
    { headerName: '삭제', field: 'authDelete', cellClass: 'cp center', width: 100,
      cellRenderer: (params) => agGridCheckbox(params, props),
      headerComponentFramework: (params) => agGridHeaderCheckbox(params, props)
    },
    { headerName: '엑셀', field: 'authExcel', cellClass: 'cp center', width: 100,
      cellRenderer: (params) => agGridCheckbox(params, props),
      headerComponentFramework: (params) => agGridHeaderCheckbox(params, props)
    },
    { headerName: 'SMS', field: 'authSms', cellClass: 'cp center', width: 100,
      cellRenderer: (params) => agGridCheckbox(params, props),
      headerComponentFramework: (params) => agGridHeaderCheckbox(params, props)
    },
    { headerName: 'Email', field: 'authEmail', cellClass: 'cp center', width: 100,
      cellRenderer: (params) => agGridCheckbox(params, props),
      headerComponentFramework: (params) => agGridHeaderCheckbox(params, props)
    },
    { headerName: 'KaKao', field: 'authKakao', cellClass: 'cp center', width: 100,
      cellRenderer: (params) => agGridCheckbox(params, props),
      headerComponentFramework: (params) => agGridHeaderCheckbox(params, props)
    },
    { headerName: '관리자', field: 'authAdmin', cellClass: 'cp center', width: 100,
      cellRenderer: (params) => agGridCheckbox(params, props),
      headerComponentFramework: (params) => agGridHeaderCheckbox(params, props)
    }
  ]);

  const [authPageList, setAuthPageList] = useState([]);
  const [gridConfigAuth, setGridUpdateAuth] = useGridConfig(2, setColumnDefsAuth);

  /***************************************************************************************
   * 설명 : 권한 그룹 가져오기
  ***************************************************************************************/
  const getAuthGroupList = async () => {
    let params = {
      program: 'admin',
      service: 'system',
      action: 'getAuthGroup',
      version: '1.0'
    }

    getApi("get", params).then( response => {
      if( response !== undefined && response.data.result ) {
        setGroupList(response.data.data);

      } else {
        setGroupList([]);
      }
    })
  }

  /***************************************************************************************
   * 설명 : 권한 그룹 셀 클릭 이벤트
  ***************************************************************************************/
  const onRowClickedGroup = (seq) => {
    setAuthgroupSeq(seq);

    let params = {
      program: 'api',
      service: 'cms',
      action: 'getAuthGroupInfo',
      version: '1.0',
      seq: seq,
      siteSeq: formik.values.siteSeq
    }

    getApi("get", params).then( response => {
      if( response !== undefined && response.data.result ) {
        setAuthPageList(response.data.data);
      } else {
        setAuthPageList([]);
      }
    })
  }

  /***************************************************************************************
   * 설명 : 권한그룹 설정 전체 선택/해제
  ***************************************************************************************/
  const selectAll = (checked) => {
    gridApiList.forEachNode( (node) => {
      node.setDataValue( 'checkrow', checked );
      node.setDataValue( 'authView', checked );
      node.setDataValue( 'authWrite', checked );
      node.setDataValue( 'authModify', checked );
      node.setDataValue( 'authDelete', checked );
      node.setDataValue( 'authExcel', checked );
      node.setDataValue( 'authSms', checked );
      node.setDataValue( 'authEmail', checked );
      node.setDataValue( 'authKakao', checked );
      node.setDataValue( 'authAdmin', checked );
    });
  }

  const setColumnAll = (e, params) => {
    params.api.forEachNode( (node) => {
      if( e.target.checked ) {
        node.setDataValue( params.column.colDef.field, 1 );
      } else {
        node.setDataValue( params.column.colDef.field, 0 );
      }
    });
  }

  /***************************************************************************************
   * 설명 : 컬럼 조정
  ***************************************************************************************/
  const setColumnCheck = (e, params) => {
    params.node.data[params.column.colDef.field] = (e.target.checked === false) ? 0 : 1;
    params.api.forEachNode( (node) => {
      if( e.target.checked ) {
        node.updateData(node.data);
      } else {
        node.updateData(node.data);
      }
    });
  }

  /***************************************************************************************
   * 설명 : 권한 그룹 저장
  ***************************************************************************************/
  const saveAuthGroup = () => {
    let data = [];
    gridApiList.forEachNode((node, i) => {
      data.push(node.data);
      data[i].authgroupSeq = authgroupSeq;
      data[i].seq = node.data.seq === null ? 0 : node.data.seq;
      data[i].menuSeq = node.data.menuSeq === null ? '' : node.data.menuSeq;
      data[i].authDelete = node.data.authDelete === null ? 0 : node.data.authDelete;
      data[i].authEmail = node.data.authEmail === null ? 0 : node.data.authEmail;
      data[i].authExcel = node.data.authExcel === null ? 0 : node.data.authExcel;
      data[i].authKakao = node.data.authKakao === null ? 0 : node.data.authKakao;
      data[i].authModify = node.data.authModify === null ? 0 : node.data.authModify;
      data[i].authSms = node.data.authSms === null ? 0 : node.data.authSms;
      data[i].authView = node.data.authView === null ? 0 : node.data.authView;
      data[i].authWrite = node.data.authWrite === null ? 0 : node.data.authWrite;
      data[i].authAdmin = node.data.authAdmin === null ? 0 : node.data.authAdmin;
    });

    if( authgroupSeq === '' ) {
      alertMsg('권한그룹명을 선택해 주세요.', 'W', MESSAGE_DELAY);
    }

    let params = {
      program: 'api',
      service: 'cms',
      action: 'setAuthGroupList',
      version: '1.0',
      data: data
    }

    getApi("post", params).then( response => {
      if( response !== undefined && response.data.result ) {
        alertMsg(response.data.message, "S", MESSAGE_DELAY);

      } else {
        alertMsg(response?.data?.message || '서버와의 통신에 실패하였습니다.', 'E', MESSAGE_DELAY);
      }
    });
  }

  /***************************************************************************************
   * 설명 : 사이트 정보 가져오기
  ***************************************************************************************/
  const getSiteInfo = () => {
    const uri = window.location.pathname;

    // 첫번째 uri 보냄 사이트 구분자
    let paramsUri = uri.split(/\//gi);

    if( paramsUri[1].indexOf('admin') !== 0 && paramsUri[1].indexOf('user') !== 0  )
      paramsUri = '/';
    else
      paramsUri = paramsUri[1];

    if( (window.location.hostname ?? '') === '' ) return;

    let params = {
      program: 'api',
      service: 'cms',
      action: 'getSiteInfo',
      version: '1.0',
      domain: window.location.hostname,
      uri: paramsUri
    }

    getApi("get", params).then( response => {
      if( response !== undefined && response.data.result && response.data.siteInfo && response.data.siteInfo.length > 0 ) {
        setSiteList(getSelectData(response.data.siteInfo, 'siteName', 'seq'));

        formik.setFieldValue('siteSeq', response.data.siteInfo[0].seq);

        getAuthGroupList();

      } else {
        setSiteList([]);
      }
    })
  }

  /***************************************************************************************
   * 설명 : Step - 2, 그룹 리스트 변경 시 페이지 데이터 가져오기
  ***************************************************************************************/
  useEffect(() => {
    if( groupList.length > 0 ) {
      onRowClickedGroup(authgroupSeq);
    }

    // eslint-disable-next-line
  }, [formik.values.siteSeq])

  /***************************************************************************************
   * 설명 : Step - 1, 사이트 정보 가져오기
  ***************************************************************************************/
  useEffect( () => {
    getSiteInfo();

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [window.location.search]);

  /***************************************************************************************
   * 설명 : html 선언부
  ***************************************************************************************/
  return (
    <Layout>
      <section className="admin-cms-contents">
        <SplitPane split="vertical" minSize={250} defaultSize={320}>
          <div className="mr10">
            <header className="admin-cms-search-header mb5">
              <div className="left">
                <div className="fl">
                  <BtnAgGridSave className="fl" click={setGridUpdateGroup}></BtnAgGridSave>
                </div>
                <div className="fl">
                  <h4 className="sub-title">권한그룹</h4>
                </div>
              </div>
              <div className="right">
              </div>
            </header>

            <section className="admin-cms-body">
              <section className="ag-theme-balham grid" style={{height:'calc(100vh - 135px)'}}>
                <div className="" style={{ height: '100%' }}>
                  <AgGridReact
                    defaultColDef={{
                      sortable: true,
                      resizable: true,
                      filter: false,
                      lockVisible: true
                    }}
                    rowSelection={'single'}
                    columnDefs={columnDefsGroup}
                    rowData={groupList}
                    onGridReady={(event) => {
                      gridConfigGroup(event.columnApi);
                    }}
                    onFirstDataRendered={(event) => {
                      event.api.forEachNode((item, index) => {
                        if(index === 0) {
                          item.setSelected(true);
                          onRowClickedGroup(item.data.seq);
                        }
                      })
                    }}
                    onRowClicked={(event) => onRowClickedGroup(event.data.seq)}
                  />
                </div>
              </section>
            </section>
          </div>

          <div className="ml10">
            <header className="admin-cms-search-header">
              <div className="left">
                <BtnSearch click={() => {
                  onRowClickedGroup(authgroupSeq);
                }}></BtnSearch>
                <BtnAgGridSave click={setGridUpdateAuth}></BtnAgGridSave>

                <SelectEx
                  name="siteSeq"
                  formik={formik}
                  fullWidth={false}
                  data={siteList}
                />
              </div>

              <div className="right">
                <Button
                  color="inherit"
                  variant="outlined"
                  className="Btn"
                  onClick={() => selectAll(1)}
                >전체선택</Button>

                <Button
                  color="error"
                  variant="contained"
                  className="ml5"
                  onClick={() => selectAll(0)}
                >전체해제</Button>

                <ButtonEx
                  title="저장"
                  auth="authModify"
                  color="primary"
                  className="ml5"
                  variant="contained"
                  onClick={saveAuthGroup}
                />
              </div>
            </header>
            <section className="admin-cms-body">
              <section className="ag-theme-balham grid" style={{height:'calc(100vh - 135px)'}}>
                <div className="" style={{ height: '100%' }}>
                  <AgGridReact
                    ref={gridRef}
                    defaultColDef={{
                      sortable: true,
                      resizable: true,
                      filter: false,
                      lockVisible: true
                    }}
                    columnDefs={columnDefsAuth}
                    rowData={authPageList}
                    onGridReady={(params) => {
                      setGridApiList(params.api);
                      gridConfigAuth(params.columnApi);
                    }}
                    overlayNoRowsTemplate="검색된 내용이 없습니다."
                  />
                </div>
              </section>
            </section>
          </div>
        </SplitPane>
      </section>
    </Layout>
  )
}

/*****************************************************************************************
 * 설명 : default export 선언
*****************************************************************************************/
export default Auth;